import { useState } from 'react'
import { message as $message } from 'antd'

import {
    queryRpaPlatform,
    queryRpaShopType,
    getFollowedCount,
    captureStatistics,
    isPlatformTypePrivate,
} from '@/services/beWorthSell'

export default () => {
    const [platforms, setPlatforms] = useState({})
    const [shopTypes, setShopTypes] = useState({})
    const [followCount, setFollowCount] = useState(0)
    const [progressCountLoading, setProgressCountLoading] = useState(false)
    const [progressCount, setProgressCount] = useState({})
    const [isPrivate, setIsPrivate] = useState(false)

    const fetchPlatforms = async () => {
        try {
            const { success, data, message } = await queryRpaPlatform()

            if (success) {
                let res = {}
                try {
                    res = JSON.parse(data)
                } catch (error) {
                    console.error('catchError', error)
                }

                setPlatforms(res || {})
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const fetchShopTypes = async () => {
        try {
            const { success, data, message } = await queryRpaShopType()

            if (success) {
                let res = {}
                try {
                    res = JSON.parse(data)
                } catch (error) {
                    console.error('catchError', error)
                }

                setShopTypes(res || {})
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const fetchCount = async () => {
        try {
            const { success, data, message } = await getFollowedCount()
            if (success) {
                setFollowCount(data || 0)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    const fetchProgressCount = async () => {
        setProgressCountLoading(true)
        try {
            const { success, data, message } = await captureStatistics()
            if (success) {
                setProgressCount(data || {})
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
        setProgressCountLoading(false)
    }

    const fetchIsPrivate = async () => {
        try {
            const { success, data, message } = await isPlatformTypePrivate()
            if (success) {
                setIsPrivate(data)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    return {
        platforms,
        fetchPlatforms,
        shopTypes,
        fetchShopTypes,
        followCount,
        fetchCount,
        progressCount,
        progressCountLoading,
        fetchProgressCount,
        isPrivate,
        fetchIsPrivate,
    }
}
